import { GET_ORG_CONTACTS, UPDATE_ORG_CONTACTS } from '../../types'
import { trackPromise } from 'react-promise-tracker'
import log from 'loglevel'
const api = (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'http:' ? 'http://' + window.location.hostname + ':3080' : (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'https:' ? 'https://' + window.location.hostname + ':8443' : process.env.REACT_APP_API_URL

export const getOrganizationalContacts = () => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }

    const response = await window.fetch(`${api}/accounts/${accountId}/contacts`, options)

    if (!response.status || response.status === 401 || response.status === 404 || response.status === 500) {
      log.warn('non 200 status code from account contacts')
    } else {
      const { data } = await response.json()
      const orgContacts = {
        accountAdministrator: data.currentContacts.adminSupervisor,
        billingContact: data.currentContacts.billingSupervisor,
        technicalContact: data.currentContacts.technicalSupervisor,
        availableContacts: data.availableContacts
      }
      dispatch({
        type: GET_ORG_CONTACTS,
        payload: orgContacts
      })
    }
  }
}

export const updateOrganizationalContacts = (accountAdministrator, billingContact, technicalContact, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const body = {
      accountAdministrator: {
        accountID: accountAdministrator.accountID,
        supervisorID: accountAdministrator.supervisorID
      },
      billingContact: {
        accountID: billingContact.accountID,
        supervisorID: billingContact.supervisorID
      },
      technicalContact: {
        accountID: technicalContact.accountID,
        supervisorID: technicalContact.supervisorID
      }
    }

    const options = {
      method: 'PUT',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/contacts`, options))
    if (!response.status || response.status === 500 || response.status === 404 || !response) {
      fireFailure()
    } else {
      dispatch({
        type: UPDATE_ORG_CONTACTS,
        payload: {
          accountAdministrator: accountAdministrator.supervisorID,
          billingContact: billingContact.supervisorID,
          technicalContact: technicalContact.supervisorID
        }
      })
      fireSuccess()
    }
  }
}
